module.exports = __webpack_public_path__ + "static/img/avator.141f7129.png";